import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import BasketballMatchRelativeRecordStore from './store';
import BasketballMatchRecordTable from './table';
import { observer } from 'mobx-react';
import BasketballMatchRecordPlayerTable from './playerTable';
import BasketballMatchRankTable from './rankTable';
import {
  Record,
  Container,
  Header,
  HeaderNonBorder,
  ChartDataContents,
  ChartDataPlayer,
  ChartDataImage,
  ChartDataInfo,
  VsSquare,
  ChartContents,
  ChartArea,
  ChartDivider,
  ChartHeader,
  Tab,
  Button
} from './styled';
import SingleBarChart from '../../../../../components/charts/bar';
import clsx from 'clsx';
import SportsTeamLogo from '../../../../../components/teamLogo';
import { _COMPARISON_CHART_INIT } from './store/constants';
import Seo from '../../../../../components/seo';

const BasketballMatchRelativeRecord = observer(() => {
  let { id } = useParams();
  const { getAll, data } = BasketballMatchRelativeRecordStore();

  useEffect(() => {
    getAll(id);
  }, []);

  if (data.loading) {
    return null;
  } else {
    return (
      <Record>
        <Seo title={'스포츠 농구 상세 전력'} />
        {/* 상대전적 시작 */}
        {data.record.vsRecord.length > 0 && (
          <Container>
            <Header>
              <h2>시즌 상대전적</h2>
            </Header>

            <BasketballMatchRecordTable data={data.record.vsRecord} />
          </Container>
        )}
        {/* 상대전적 끝 */}
        {/* 최근 5경기 */}
        <Container>
          <Header>
            <h2>최근 5경기</h2>
          </Header>

          <Tab>
            <Button
              className={clsx(
                data.record.selectedRecentRecordTab === 'home' ? 'active' : ''
              )}
              onClick={() => data.record.onClickTab('home')}
            >
              {data.record.tabs.home}
            </Button>
            <Button
              className={clsx(
                data.record.selectedRecentRecordTab === 'away' ? 'active' : ''
              )}
              onClick={() => data.record.onClickTab('away')}
            >
              {data.record.tabs.away}
            </Button>
          </Tab>

          <BasketballMatchRecordTable data={data.record.recentRecord} />
        </Container>
        <Container>
          <HeaderNonBorder>
            <h2>팀 시즌 성적</h2>
          </HeaderNonBorder>
          <ChartDataContents>
            <ChartDataPlayer>
              <ChartDataImage>
                <SportsTeamLogo
                  imgSize={60}
                  imgUrl={data.teamStat.home.imgPath}
                  isLazy={false}
                  location="home"
                />
              </ChartDataImage>
              <ChartDataInfo>
                <span>{data.teamStat.home.name}</span>
                <span>{data.teamStat.home.stat.season}</span>
              </ChartDataInfo>
            </ChartDataPlayer>

            <VsSquare>
              <span>VS</span>
            </VsSquare>

            <ChartDataPlayer>
              <ChartDataImage>
                <SportsTeamLogo
                  imgSize={60}
                  imgUrl={data.teamStat.away.imgPath}
                  isLazy={false}
                  location="away"
                />
              </ChartDataImage>
              <ChartDataInfo>
                <span>{data.teamStat.away.name}</span>
                <span>{data.teamStat.away.stat.season}</span>
              </ChartDataInfo>
            </ChartDataPlayer>
          </ChartDataContents>

          {/* 차트 */}
          <ChartContents>
            {Object.keys(_COMPARISON_CHART_INIT).map((key, idx) => {
              return (
                <li key={_COMPARISON_CHART_INIT[key].key}>
                  <ChartHeader>
                    <span>{data.comparisonChart[key].home.v}</span>
                    <span>{_COMPARISON_CHART_INIT[key].name}</span>
                    <span>{data.comparisonChart[key].away.v}</span>
                  </ChartHeader>
                  <ChartArea>
                    <SingleBarChart
                      value={data.comparisonChart[key].home.p}
                      active={
                        data.comparisonChart[key].visible &&
                        data.comparisonChart[key].home.active
                      }
                      location="left"
                    />
                    <ChartDivider />
                    <SingleBarChart
                      value={data.comparisonChart[key].away.p}
                      active={
                        data.comparisonChart[key].visible &&
                        data.comparisonChart[key].away.active
                      }
                      location="right"
                    />
                  </ChartArea>
                </li>
              );
            })}
          </ChartContents>
        </Container>
        {/* 전력 비교 끝 */}

        {/* 개인 시즌 성정 */}
        <Container>
          <HeaderNonBorder>
            <h2>개인 시즌 성적</h2>
          </HeaderNonBorder>
          <BasketballMatchRecordPlayerTable data={data.playerStat} />
        </Container>

        {/* 팀 순위 */}
        <Container>
          <BasketballMatchRankTable data={data.rank} team={data.teamStat} />
        </Container>
      </Record>
    );
  }
});

export default BasketballMatchRelativeRecord;
